import { useFormaliteService } from '@europrocurement/l2d-domain';
import { FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead } from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type DossierFormalite = {
    id: number;
    libelle: string;
    categorieId: number;
    categorieLibelle: string;
} & Record<string, unknown>;

const useDossierFormalite = () => {
    const { formaliteOpenSearchApi } = useFormaliteService();
    let searchFormalisteTimeout: number | undefined;

    const searchDossierFormalite = (term: string): Promise<Array<DossierFormalite>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchFormalisteTimeout);
            const requestParameters = {
                q: term || undefined,
                itemsPerPage: 200,
            };

            searchFormalisteTimeout = setTimeout(() => {
                formaliteOpenSearchApi
                    .apiOpensearchFormalitesGetCollection(requestParameters)
                    .then((res) => {
                        const items = res.data[
                            'hydra:member'
                        ] as Array<FormaliteArticleOpenSearchJsonldOpensearchFormaliteArticleRead>;

                        const expanded: DossierFormalite[] = [];

                        items.forEach((item) => {
                            const categories = item.categorie;
                            if (categories && categories.length > 0) {
                                categories.forEach((cat) => {
                                    expanded.push({
                                        id: item.id as number,
                                        libelle: item.libelle as string,
                                        categorieId: cat.id as number,
                                        categorieLibelle: cat.libelle as string,
                                    });
                                });
                            }
                        });

                        resolve(expanded);
                    })
                    .catch(() => reject());
            }, 300);
        });

    return { searchDossierFormalite };
};

export default useDossierFormalite;
